import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles.css';
import AppRouter from './router/AppRouter';
import AppProvider from './store/app/appProvider';
import NotificationProvider from './store/notification/notificationProvider';
import TokenExpiry from './containers/app/TokenExpiry';

require('dotenv').config();
  
ReactDOM.render(
  <React.StrictMode>
    <NotificationProvider>
      <AppProvider>
        <TokenExpiry />
        <Router>
          <AppRouter />
        </Router>
      </AppProvider>
    </NotificationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
